import { render, staticRenderFns } from "./SeleccionBodega.vue?vue&type=template&id=8e024f4e&scoped=true"
import script from "./SeleccionBodega.vue?vue&type=script&lang=js"
export * from "./SeleccionBodega.vue?vue&type=script&lang=js"
import style0 from "./SeleccionBodega.vue?vue&type=style&index=0&id=8e024f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e024f4e",
  null
  
)

export default component.exports